var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ps-lg-7 pt-4"},[_c('h1',{staticClass:"text-h6 fw-700 mb-3"},[_vm._v(" "+_vm._s(_vm.$t('flow_no'))+": "+_vm._s(_vm.order.code)+" ")]),_c('Summary',{attrs:{"order-details":_vm.order},on:{"reload":function($event){return _vm.getDetails(_vm.$route.params.code)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }